export default __webpack_public_path__ + "media/images/promare/promare4-cd25d70a861962bdd97e8400a613ea25.jpg";